
import moment from "moment";
import html2pdf from "html2pdf.js";

import Controller from "dbl-components/lib/js/controller";
import { mergeWithMutation } from "dbl-components/lib/js/functions/deep-merge";

import appCtrl from "../app-controller";

export default class CvController extends Controller {

  static jsClass = 'CvController';

  constructor(props) {
    super(props);
    this.events.push(
      ['showMoreSkills', this.onShowMoreSkills.bind(this)],
      ['showLessSkills', this.onShowLessSkills.bind(this)],
      ['showMoreJobs', this.onShowMoreJobs.bind(this)],
      ['showLessJobs', this.onShowLessJobs.bind(this)],
      ['pdfBtn', this.onClickPdfBtn.bind(this)],
      ['langSelect', this.onChangeLang.bind(this)]
    );
    this.definitions = appCtrl.getViewDefinitions('cv');
    Object.assign(this.state, {
      showMoreSkills: false,
      showMoreJobs: false,
      pdf: false
    });
  }

  async componentDidMount() {
    super.componentDidMount();
    const [about, portfolio, skills, jobs, education] = await Promise.all([
      appCtrl.fetch('/api/about.json'),
      appCtrl.fetch('/api/portfolio.json'),
      appCtrl.fetch('/api/skills.json'),
      appCtrl.fetch('/api/jobs.json'),
      appCtrl.fetch('/api/education.json'),
    ]);

    if (about.data) {
      this.state.about = about.data;
    }

    if (portfolio.data) {
      this.state.portfolio = portfolio.data
        .map(item => ({
          name: item.name,
          tag: 'a',
          _props: {
            target: '_blank',
            href: item.link
          },
          content: item.label
        }))
    }

    if (skills.data) {
      const skillsContainer = [[], {
        name: 'pdfGotoSite',
        ...this.definitions.pdfGotoSite
      }, {
        name: 'showMoreSkills',
        component: 'Action',
        content: '=== Ver más ===',
        classes: 'btn-link d-block w-100'
      }, {
        active: false,
        name: 'moreSkills',
        content: []
      }, {
        name: 'showLessSkills',
        component: 'Action',
        content: '=== Ver menos ===',
        classes: 'btn-link d-block w-100'
      }];
      this.state.allSkills = [];
      const data = skills.data.reduce((reducer, skill, i) => {
        const theArray = skill.best ? reducer[0] : reducer[3].content;
        const builded = this.buildSchemaSkills(skill, i);
        theArray.push(builded);
        this.state.allSkills.push(builded);
        return reducer;
      }, skillsContainer);
      this.state.skills = data.flat();
    }
    if (jobs.data) {
      const jobsContainer = [[], {
        name: 'pdfGotoSite',
        ...this.definitions.pdfGotoSite
      }, {
        name: 'showMoreJobs',
        component: 'Action',
        content: '=== Ver más ===',
        classes: 'btn-link d-block w-100'
      }, {
        active: false,
        name: 'moreJobs',
        content: []
      }, {
        name: 'showLessJobs',
        component: 'Action',
        content: '=== Ver menos ===',
        classes: 'btn-link d-block w-100'
      }];
      this.state.allJobs = [];
      const data = jobs.data.reduce((reducer, job, i) => {
        const theArray = job.latest ? reducer[0] : reducer[3].content;
        const builded = this.buildSchemaJobs(job, i);
        theArray.push(builded);
        this.state.allJobs.push(builded);
        return reducer;
      }, jobsContainer);
      this.state.jobs = data.flat();
    }
    if (education.data) {
      const data = education.data.reduce((reducer, e, i) => {
        reducer.push(this.buildSchemaEducation(e, i));
        return reducer;
      }, []);
      this.state.education = data;
    }
    this.setState({ ready: true });
  }

  onChangeLang({ langSelect }) {
    appCtrl.setLang(langSelect);
  }

  onClickPdfBtn() {
    this.setState({
      pdf: true
    }, () => {
      setTimeout(this.generatePdf.bind(this), 1600);
    });
  }

  async generatePdf() {
    const element = this.ref.current.querySelector('.topGrid-GridContainer');
    const opts = {
      margin: [.2, .1],
      filename: this.state.about.name + '.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
    document.body.classList.add('printing');
    await html2pdf(element, opts);
    document.body.classList.remove('printing');
    this.setState({ pdf: false });
  }

  onShowMoreSkills() {
    this.toggleSkills(true);
  }

  onShowLessSkills() {
    this.toggleSkills(false);
  }

  toggleSkills(showMoreSkills) {
    this.setState({ showMoreSkills });
  }

  onShowMoreJobs() {
    this.toggleJobs(true);
  }

  onShowLessJobs() {
    this.toggleJobs(false);
  }

  toggleJobs(showMoreJobs) {
    this.setState({ showMoreJobs });
  }

  buildSchemaSkills(skill, i) {
    const schema = JSON.parse(JSON.stringify(this.definitions.skill));
    Object.assign(schema, schema.$);
    delete schema.$;
    schema.name = 'skill.' + skill.name;
    schema._props.title = skill.description[appCtrl.props.lang];
    return mergeWithMutation(schema, {
      mutation: this.skillsBuildMutation.bind(this),
      data: [skill, i],
      ommit: ['$']
    });
  }

  buildSchemaJobs(job, i) {
    const schema = JSON.parse(JSON.stringify(this.definitions.job));
    Object.assign(schema, schema.$);
    delete schema.$;
    schema.name = 'job.' + job.company;
    return mergeWithMutation(schema, {
      mutation: this.jobsBuildMutation.bind(this),
      data: [job, i],
      ommit: ['$']
    });
  }

  buildSchemaEducation(education, i) {
    const schema = JSON.parse(JSON.stringify(this.definitions.education));
    Object.assign(schema, schema.$);
    delete schema.$;
    schema.name = 'education.' + education.name;
    return mergeWithMutation(schema, {
      mutation: this.educationBuildMutation.bind(this),
      data: [education, i],
      ommit: ['$']
    });
  }

  skillsBuildMutation(key, obj, [skill, i]) {
    const $ = obj.$;
    delete obj.$;
    switch (key) {
      case 'nameSkill':
        return {
          ...$, name: `${key}.${skill.name}`,
          _props: {
            href: skill.link,
            target: '_blank'
          }
        };
      case 'icoSkill':
        if (!skill.icon) return { active: false }
        return {
          ...$, name: `${key}.${skill.name}`,
          src: skill.icon
        };
      case 'textSkill':
        return { content: skill.label }
      case 'progressSkill':
        return {
          ...$, name: `${key}.${skill.name}`,
          _props: {
            'aria-label': skill.label,
            'aria-valuenow': `${skill.percent * 100}%`,
          }
        };
      case 'bar':
        return {
          ...$, name: `${key}.${skill.name}`,
          style: {
            width: `${skill.percent * 100}%`
          }
        };
      default:
        break;
    }
  }

  jobsBuildMutation(key, obj, [job, i]) {
    const $ = obj.$;
    delete obj.$;
    switch (key) {
      case 'nameJob': {
        return {
          ...$, name: `${key}.${job.company}`,
          "_props": {
            "href": job.link,
            "title": job.label,
            target: "_blank"
          }
        };
      }
      case 'icoJob': {
        return {
          ...$, name: `${key}.${job.company}`,
          src: job.logo
        };
      }
      case 'textJob': {
        return {
          ...$, name: `${key}.${job.company}`,
          content: job.company
        };
      }
      case 'separador': {
        return {
          ...$, name: `${key}.${job.company}`
        };
      }
      case 'puesto': {
        return {
          ...$, name: `${key}.${job.company}`,
          content: job.position
        };
      }
      case 'from': {
        return {
          ...$, name: `${key}.${job.company}`,
          content: moment(job.startDate).format('MMM/YYYY')
        }
      }
      case 'to': {
        return {
          ...$, name: `${key}.${job.company}`,
          content: moment(job.endDate).format('MMM/YYYY')
        }
      }
      case 'descriptionJob': {
        return {
          ...$, name: `${key}.${job.company}`,
          content: job.description[appCtrl.props.lang]
        };
      }
      case 'skillsJob': {
        return {
          ...$, name: `${key}.${job.company}`,
          style: {
            transform: 'scale(0.8)'
          },
          content: job.skills?.reduce((reducer, skillName) => {
            const skillTpl = this.state.allSkills.find(s => s.name === `skill.${skillName}`);
            if (!!skillTpl) {
              const iconSkill = JSON.parse(JSON.stringify(skillTpl.content.nameSkill));
              reducer.push(iconSkill);
            }
            return reducer;
          }, [])
        };
      }
      default:
        break;
    }
  }

  educationBuildMutation(key, obj, [education, i]) {
    const $ = obj.$;
    delete obj.$;
    switch (key) {
      case 'nameEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
          "_props": {
            "href": education.link,
            "title": education.label,
            target: "_blank"
          }
        }
      }
      case 'icoEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
          src: education.logo
        }
      }
      case 'textEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
          content: education.label
        }
      }
      case 'separador': {
        return {
          ...$, name: `${key}.${education.name}`
        };
      }
      case 'school': {
        return {
          ...$, name: `${key}.${education.name}`,
          content: education.school
        }
      }
      case 'datesEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
        }
      }
      case 'from': {
        return {
          ...$, name: `${key}.${education.name}`,
          content: moment(education.startDate).format('MMM/YYYY')
        }
      }
      case 'to': {
        return {
          ...$, name: `${key}.${education.name}`,
          content: moment(education.endDate).format('MMM/YYYY')
        }
      }
      case 'descriptionEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
          content: education.description[appCtrl.props.lang]
        }
      }
      case 'skillsEducation': {
        return {
          ...$, name: `${key}.${education.name}`,
          style: {
            transform: 'scale(0.8)'
          },
          content: education.skills?.reduce((reducer, skillName) => {
            const skillTpl = this.state.allSkills.find(s => s.name === `skill.${skillName}`);
            if (!!skillTpl) {
              const iconSkill = JSON.parse(JSON.stringify(skillTpl.content.nameSkill));
              reducer.push(iconSkill);
            }
            return reducer;
          }, [])
        }
      }
      default:
        break;
    }
  }

  mutations(name, section) {
    switch (name) {
      case 'langSelect': {
        return {
          active: !this.state.pdf,
          default: appCtrl.props.lang
        }
      }
      case 'topGrid': {
        return {
          wrapperClasses: this.state.pdf ? 'pdf-building' : null
        };
      }
      case 'pdfBtn': {
        return {
          active: !this.state.pdf
        }
      }
      case 'name': {
        return {
          content: this.state.about?.name
        }
      }
      case 'job': {
        return {
          content: this.state.about?.position
        }
      }
      case 'profile': {
        return {
          content: this.state.about?.description[appCtrl.props.lang][0]
        }
      }
      case 'guidelines': {
        return {
          content: this.state
            .about?.guidelines.map(g => g[appCtrl.props.lang])
        }
      }
      case 'phrase': {
        return {
          content: this.state
            .about?.phrase.text[appCtrl.props.lang]
        }
      }
      case 'phone': {
        return {
          _props: {
            target: "_blank",
            href: 'tel:' + this.state.about?.phone
          },
          content: this.state.about?.phone
            .replace(/(\d{2})(\d{2})(\d{4})(\d{4})/, '$1 $2 $3 $4')
        }
      }
      case 'whatsapp': {
        const match = this.state.about?.whatsapp
          .match(/phone=(\d{2})(\d{2})(\d{4})(\d{4})/) || [];
        return {
          _props: {
            target: "_blank",
            href: this.state.about?.whatsapp
          },
          content: '+' + match.slice(1).join(' ')
        }
      }
      case 'webSite': {
        return {
          _props: {
            target: "_blank",
            href: this.state.about?.website
          },
          content: this.state.about?.website
            .replace(/(https:\/\/(www.)?)/, '')
        }
      }
      case 'email': {
        return {
          _props: {
            target: "_blank",
            href: 'email:' + this.state.about?.email
          },
          content: this.state.about?.email
        }
      }
      case 'linkedin': {
        return {
          _props: {
            target: "_blank",
            href: this.state.about?.linkedin
          },
          content: this.state.about?.linkedin
            .replace(/(https:\/\/(www.)?)/, '')
        }
      }
      case 'portfolio': {
        return {
          content: this.state.portfolio
        }
      }
      case 'skills':
        section.content = this.state.skills;
        return {
          active: !!this.state.skills?.length
        }
      case 'showMoreSkills': {
        return {
          active: !this.state.showMoreSkills && !this.state.pdf
        };
      }
      case 'showLessSkills':
      case 'moreSkills': {
        return {
          active: !!this.state.showMoreSkills && !this.state.pdf
        };
      }
      case 'pdfGotoSite': {
        return {
          active: !!this.state.pdf
        }
      }
      case 'pdfCvLink': {
        return {
          active: !!this.state.pdf,
          _props: {
            title: "Ver CV en Línea",
            target: "_blank",
            href: appCtrl.get('thisUrl')
          },
        }
      }
      case 'workExperience':
        section.content = this.state.jobs;
        return {
          active: !!this.state.jobs?.length
        }
      case 'showMoreJobs': {
        return {
          active: !this.state.showMoreJobs && !this.state.pdf
        };
      }
      case 'showLessJobs':
      case 'moreJobs': {
        return {
          active: !!this.state.showMoreJobs && !this.state.pdf
        };
      }
      case 'education': {
        section.content = this.state.education;
        return {
          active: !!this.state.education?.length
        }
      }
      default:
        break;
    }
  }
}